/**
* In this file use to contains the physician Module profile View screen UI and Logic
**/
import { Link } from 'react-router-dom';
import { useState,useEffect} from 'react';
import ApiService from './../../../services/ApiService';
import { goBack ,convertTimeFormat,convertS3privateToPublic } from './../../../services/UtilsService';
import { useDispatch } from 'react-redux'
import { useTranslation } from 'react-i18next';

function ViewPhysician() {
	
		//Intial state declaration
		const [data,setData]=useState({});
		const dispatch = useDispatch();
		const { t } = useTranslation();
		
    //Component Initialize function
	useEffect(()=>{
	   (async()=>{
		     var response=await ApiService.getProfile();
			 if(response.status===200){
					setData(response.data);	 	
					dispatch({type:"PROFILE",payload:response.data.profile});
				}
				if (response.data.profile) {
					const createdBy = response.data.profile.created_by; // Get the created_by value
					localStorage.setItem("created_by", createdBy); // Store it in localStorage with the key "created_by"
				}
				if (response.data.profile) {
					const account = response.data.profile.account; // Get the created_by value
					localStorage.setItem("id", account); // Store it in localStorage with the key "created_by"
				}
				
				
	   })();
	   // eslint-disable-next-line
   },[]);
   
   
  return (
   <main id="main" className="main">
   {/*Page Title Section*/}
		<div className="pagetitle clearfix">
		<div className="float-start">
		  <h1>{t('header.myProfile')}</h1>
			<nav>
				<ol className="breadcrumb">
				  <li className="breadcrumb-item"><Link to='/physician/dashboard'>{t('sidebar.home')}</Link></li>
				  <li className="breadcrumb-item active">{t('header.myProfile')} </li>
				</ol>
			</nav>
		</div>
		<div className="float-end mt-2 me-1">
			<span onClick={goBack}   className="backIcon"><i className="iconly-Bold-ArrowLeftSquare"></i></span>
		</div>
	</div>
	{/*End Page Title Section*/}
	
	{/*Page Content Section*/}
		<section>
	<div className="row">
	{/*ProfileImg*/}
		<div className="col-xxl-4">
			<div className="card profile-img">
				<div className="card-body">
					<div className="top-bar">
						{(data && data?.profile && data?.profile?.photo ==='default.png') && <img className="img-fluid d-block mx-auto" src="/assets/img/user-avatar.png" alt="IMG" />}
						{(data && data?.profile && data?.profile?.photo !=='default.png') && <img src={convertS3privateToPublic(data?.profile?.photo)} className="img-fluid d-block mx-auto" alt="IMG" />}
						<h1 className="text-capitalize">{data.profile?.first_name?data.profile.first_name+' '+data.profile.last_name:'--'}</h1>
						
					</div>
					<div className="center-bar clearfix">
						<div className="d-flex align-items-center mb-4">
							<div className="info-icon">
								<i className="iconly-Bold-Send"></i>
							</div>
							<div className="ms-2">
								<p className="mb-0 text-tmBlue">{t('profile.email')}</p>
								<span className="h6 text-dark" style={{ wordBreak : "break-word"}}>{data.profile?.email?data.profile.email:'--'}</span>
							</div>
						</div>
						<div className="d-flex align-items-center mb-4">
							<div className="info-icon">
								<i className="iconly-Bold-Calling"></i>
							</div>
							<div className="ms-2">
								<p className="mb-0 text-tmBlue">{t('profile.phone')}</p>
								<span className="h6 text-dark">{data.profile?.phoneNumber?data.profile.phoneNumber:'--'}</span>
							</div>
						</div>
					</div>
					<div className="d-grid mt-4">
						<Link to='/physician/edit-profile' className="btn btn-block btn-outline-tmBlue">
							<i className="ri-edit-2-fill align-middle"></i> {t('profile.editProfile')}
						</Link>
					</div>
				</div>
			</div>
		</div>
		{/*ProfileInfo*/}
		<div className="col-xxl-8">
			<div className="card profile-info">
				<div className="card-body pt-4">
					<div className="row">
						<div className="col-xxl-12 px-3 mb-5">
							<div className="secTitle">
								<h1>{t('profile.physicianInfo')}</h1>
							</div>
							<div className="secContent">
								<h6>{t('profile.location')}</h6>
								<p className="text-capitalize">
								  {data.profile && data.profile.address_one
									? 'Address One: '+ data.profile.address_one + ', '
									: ''}{data.profile && data.profile.address_one && <br/ >}
								  {data.profile && data.profile.address_two
									? 'Address Two: '+data.profile.address_two + ', '
									: ''}{data.profile && data.profile.address_two && <br/ >}
								  {(data.profile && data.profile.city ) ? 'City: '+ data.profile.city+', ':''}{data.profile && data.profile.city && <br/ >}
									{(data.profile && data.profile.state) ? 'State: '+data.profile.state+', ':''} {data.profile && data.profile.state && <br/ >}
									{(data.profile && data.profile.zipcode) ? 'Zipcode :'+data.profile.zipcode:''}{data.profile && data.profile.zipcode && <br/ >}
									{!(data.profile && (data.profile.city || data.profile.state || data.profile.zipcode)) ? '--' : ''}
								</p>

								<h6>{t('profile.outOfOffice')}</h6>
									<p>
									{data?.profile?.out_of_office?.length === 0
										? "--" // Case 1: No out-of-office dates
										: data?.profile?.out_of_office
											?.map((range) => {
											// Remove square brackets and split the range
											const [start, end] = range.replace(/[\[\]]/g, "").split(",");
											if (start === end) {
												// Case 3: Same start and end date
												return new Date(start).toLocaleDateString("en-GB");
											} else {
												// Case 2: Different start and end dates
												return `${new Date(start).toLocaleDateString("en-GB")} -to- ${new Date(end).toLocaleDateString("en-GB")}`;
											}
											})
											.join(", ")} {/* Join all formatted dates with a comma */}
								</p>
							</div>
						</div>
					</div>
					<div className="row">
						<div className="col-xxl-12 px-3 mb-5">
							<div className="secTitle">
								<h1>{t('profile.hospitalInfo')}</h1>
							</div>
							<div className="secContent">
								<div className="table-responsive">	
									<table className="table table-borderless theme-table">
										<thead>
										  <tr>
											<th scope="col">{t('profile.hospital')}</th>
											<th scope="col">{t('profile.visitingDays')}</th>
											<th scope="col">{t('profile.visitingHours')}</th>
											<th scope="col">{t('profile.consultingDuration')}</th>
										  </tr>
										</thead>
										{data && data?.hospitalInfo?.length ? (
										<tbody>
											{data && data.hospitalInfo && data.hospitalInfo.map(item=>(
											<tr key={item.id}>
												<td className="prty-td">
													<span>
														<h5 className="table-title text-capitalize">{item?.hospital_name?item?.hospital_name:'--'}</h5>
													</span>
												</td>					
												<td className="text-capitalize">
												{item?.days && item?.days.length > 0 ? (
													item?.days
													.map(day =>[day.trim()] || '--') 
													.reduce((acc, curr, index) => (
													<>
														{acc}
														{index > 0 && ', '}
														{curr}
													</>
													), '')) : (
														'--' // Change: Added fallback for no days
													)}
												</td>
												<td>
													{item.startTime && item.endTime ? `${convertTimeFormat(item.startTime)} to ${convertTimeFormat(item.endTime)}` : '--'}
												</td>	
												<td>{item.consultingDuration!==null ? item.consultingDuration + ' Mins' : '--'}</td>
											</tr>
											))}
											</tbody>
											) : (
											<tbody>
												<tr>
													<td colSpan="4" className="text-center">{t('common.noRecord')}</td>
												</tr>
											</tbody>
											)}
									</table>
								</div>
							</div>
						</div>
					</div>
					<div className="row">
						<div className="col-xxl-12 px-3 mb-5">
							<div className="secTitle">
								<h1>{t('profile.PatientInfo')}</h1>
							</div>
							<div className="secContent">
								<div className="table-responsive">	
									<table className="table table-borderless theme-table">
										<thead>
										  <tr>
											<th scope="col">{t('profile.patient')}</th>
											<th scope="col">{t('profile.familyMember')}</th>
										  </tr>
										</thead>
										{data && data?.parentInfo?.length ? (
										<tbody>
											{data && data.parentInfo && data.parentInfo.map(item=>(
											<tr key={item.id}>
												<td  className="prty-td">
													<span className="text-capitalize">
														<h5 className="table-title">{item?.parent_name ? item?.parent_name:'--'}</h5>
													</span>
												</td>
												<td>{item?.members?item?.members:0}</td>		
											</tr>
											))}
											</tbody>
											) : (
											<tbody>
												<tr>
													<td colSpan="2" className="text-center">{t('common.noRecord')}</td>
												</tr>
											</tbody>
											)}
									</table>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</section>
{/*End Page Content Section*/}
	</main>
  );
}

export default ViewPhysician;
